var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RatioBox',_vm._b({},'RatioBox',_vm.$attrs,false),[_c('div',{staticClass:"d-flex justify-center align-center h100"},[_c('v-icon',{attrs:{"large":"","color":_vm.iconColor}},[_vm._v(" mdi-file-pdf-box ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }